<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
name: "baseBar";
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  console.log(listData)
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  let legendData = [];
  let seriesData = [];
  let colorArr = ['rgba(77,186,217,1)', 'rgba(167,219,121,1)', 'rgba(54,237,162,1)', 'rgba(112,141,252,1)'];
  let colorArr1 = ['rgba(77,186,217,0)', 'rgba(167,219,121,0)', 'rgba(54,237,162,0)', 'rgba(112,141,252,0)'];
  legendData = listData.list.map((item) => item.name);
  seriesData = listData.list.map((item1, index1) => {
    return {
      name: item1.name,
      type: 'bar',
      barWidth: 15,
      silent: true,
      itemStyle: {
        normal: {
          color:  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: colorArr[index1],
            },
            {
              offset: 1,
              color: colorArr1[index1],
            },
          ]),
            // colorArr[index1],
        },
      },
      data: item1.value,
    }
  })


  const option = {
    grid: {
      containLabel: true,
      bottom: '5%',
      top: '25%',
      left: '5%',
      right: '5%',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      orient: 'horizontal',
      top: '4%',
      right: 'center',
      left:'center',
      data: legendData,
      itemWidth: 13,
      itemHeight: 9,
      itemGap: 40,
      icon: "rect",
      textStyle: {
        fontSize: 13,
        color: '#fff',
        padding: [5, 0, 0, 2],
        rich: {
          a: {
            verticalAlign: 'middle',
          },
        },
      },

    },
    xAxis: {
      triggerEvent: true,
      data: listData.time,
      axisLabel: {
        show: true,
        fontSize: 14,
        color: '#fff',
        align: 'center',
        verticalAlign: 'top',
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: [
      {
        name: "单位（万亩）",
        nameTextStyle: {
          color: "#fff",
          fontSize: 14,
          padding: [0, 0, 10, 0]
        },
        axisLabel: {
          interval: 0,
          show: true,
          fontSize: 14,
          color: '#fff',
        },
        axisLine: {
          show: false,
          lineStyle: {
            type: 'solid',
            color: '#324157',
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            type: 'solid',
            color: 'rgba(50,65,87,.3)',
          },
        },
      },
    ],
    series: seriesData,
  };// 将你的ECharts配置项放在这里

    chartInstance.setOption(option, true);
}

window.addEventListener("resize", () => {
  chartInstance.resize();
});

</script>
<style lang="less"></style>
